import {FormControl, Segment} from 'platform/components';
import {Box, Show, Space, Text, VStack} from 'platform/foundation';

import {useState} from 'react';
import {UseFormReturn} from 'react-hook-form';
import {useLocation} from 'react-router-dom';

import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';
import {SettingsFooter, SettingsSection} from '@dms/settings/shared';

import {Nullish, useNavigate} from 'shared/web';

import {FormType} from '../../types/ServiceOrderVariant';
import {getServiceOrderVariantsRoutes} from '../../utils/getServiceOrderVariantsRoutes';
import {ServiceOrderMandatoryFields} from './components/ServiceOrderMandatoryFields';
import {VehicleMandatoryFields} from './components/VehicleMandatoryFields';

interface GeneralTabProps {
  control: FormControl<FormType>;
  formApi: UseFormReturn<FormType>;
  selectedOrderTypeCode: string | Nullish;
}

type SegmentValue = 'service_order' | 'vehicle';

export function MandatoryFieldsTab(props: GeneralTabProps) {
  const {pathname} = useLocation();
  const navigate = useNavigate();
  const serviceOrderVariantsRoutes = getServiceOrderVariantsRoutes(pathname);

  const [segmentValue, setSegmentValue] = useState<SegmentValue>('service_order');

  return (
    <>
      <SettingsSection>
        <VStack spacing={4}>
          <Box width={75}>
            <Segment
              value={segmentValue}
              onChange={(value: SegmentValue) => setSegmentValue(value)}
              options={[
                {label: i18n.t('entity.warehouse.labels.serviceOrder'), value: 'service_order'},
                {label: i18n.t('entity.vehicle.labels.vehicle'), value: 'vehicle'},
              ]}
            />
          </Box>
          <Text color="secondary" size="small">
            {i18n.t('entity.order.labels.mandatoryFieldsDescription')}
          </Text>
          <Show when={segmentValue === 'service_order'}>
            <ServiceOrderMandatoryFields
              selectedOrderTypeCode={props.selectedOrderTypeCode}
              control={props.control}
              formApi={props.formApi}
            />
          </Show>
          <Show when={segmentValue === 'vehicle'}>
            <VehicleMandatoryFields control={props.control} formApi={props.formApi} />
          </Show>
        </VStack>
      </SettingsSection>
      <Space vertical={20} />
      <SettingsFooter
        actions={[
          {
            type: 'button',
            variant: 'secondary',
            title: i18n.t('general.actions.discardChanges'),
            onClick: () => navigate(serviceOrderVariantsRoutes.overview),
          },
          {
            type: 'form-button',
            control: props.control,
            buttonType: 'submit',
            variant: 'primary',
            title: i18n.t('general.actions.saveChanges'),
          },
        ]}
        data-testid={testIds.settings.serviceOrderVariantsDetail('footer')}
      />
    </>
  );
}
